/* eslint-disable import/first */
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Home } from '../Icons';
import { ImArrowRight2 } from '@react-icons/all-files/im/ImArrowRight2';
import css from './index.module.scss';
import ClassNames from 'classnames';

const NoAddress = ({ urlPathToMode, location, page, navigate }) => {
  const intl = useIntl();
  const handleClick = (e) => {
    e.preventDefault();
    navigate(`/${intl.locale}${urlPathToMode}`);
  };
  return (
    <div
      className={ClassNames(css.noAddress, { [css.removeSpace]: page === 'checkout' })}
      onClick={handleClick}
    >
      <div className={css.icon}>
        <Home />
      </div>
      <div className={css.title}>
        <FormattedMessage id="addaddress_selectlocation" defaultMessage="Select Location" />
      </div>
      <div className={css.arrow}>
        <ImArrowRight2 />
      </div>
    </div>
  );
};

export default NoAddress;
